import { Environment } from 'src/lib'

export const TOTAL_STEPS = {
  REGULAR: 5,
  ALL_CLINICS: 6,
  CITY: 6,
  SHORTER_FLOW: 4,
}
export const SOONEST_AVAILABLE_PRACTITIONER_ID = 'SOONEST_AVAILABLE_PRACTITIONER_ID'

export const DATE_FORMATS = {
  DAY_MONTH_YEAR: {
    de: 'dd. MMMM yyyy',
    en: 'dd MMMM yyyy',
  },
  WEEKDAY_DAY_MONTH_YEAR_TIME: {
    de: 'E dd. MMMM yyyy | HH:mm',
    en: 'E. dd MMMM yyyy | HH:mm',
  },
  DAY_MONTH_YEAR_TIME: {
    de: 'dd. MMMM yyyy | HH:mm',
    en: 'dd MMMM yyyy | HH:mm',
  },
  TIME: 'HH:mm',
  APPOINTMENT_CONFIRMATION: {
    de: "EEEE, dd.MM.yyyy 'um' HH:mm",
    en: "EEEE, dd.MM.yyyy 'at' HH:mm a",
  },
  DAY_MONTH: 'd MMMM',
}

export const GENERAL_TERMS_AND_CONDITIONS_SUBPAGE = '/general-terms-and-conditions/'

export const fiveMinutesInMiliseconds = 5 * 60 * 1000

export const childProphylaxisTreatmentPurposeIds = [
  '39b97e61-ce25-4e7b-b35a-156acd9a36e4', // staging
  '431d9ae7-0b36-4d7a-993f-c40d359f9ca0', // production
]

export const suggestedTreamentsPurposeIds = {
  [Environment.Production]: [
    '0f9e7ee0-a610-4eff-a6ee-aee2a5fd557b', // kontrolle
    '0e4c0b98-7c99-4cef-b77a-9eeb3880ee19', // teeth cleaning
    '721ee3c0-1eef-43c4-8c39-e74555218c6c', // pain treatment
    '79788039-8303-40a3-bbe5-068f06f03057', // bleaching
    '90a9b2fe-e918-4d87-9df6-6ab78d9c2263', // invisalign
    '1b8378f4-c5a0-4261-a8f9-64c8ef33e71c', // implants
  ],
  [Environment.Staging]: [
    '2d115599-ef24-4091-86d2-b60dfbab701e', // kontrolle
    'fca06830-086f-4a61-b796-20ad9cbc0a89', // teeth cleaning
    '5644a5b1-1ceb-424c-a3a5-a0fc66dfb5d4', // pain treatment
    'aa7391a9-de70-4a69-876f-9d3890b7076f', // bleaching
    'cead4f30-b7b2-4281-a900-203a32a8e4d3', // invisalign
    '', // implants
  ],
}
